module.exports = __webpack_public_path__ + "img/wlkycy.75a01802.png";